import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../../services/common.service';
import * as moment from 'moment';

@Component({
  selector: 'app-compta',
  templateUrl: './compta.component.html',
  styleUrls: ['./compta.component.css']
})
export class ComptaComponent implements OnInit {
  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Input() hidetitle: Boolean;

  @Output() ibanBic = new EventEmitter<any>();
  @Output() tropPercus = new EventEmitter<any>();
  @Output() montantsTeom = new EventEmitter<any>();
  @Output() compteCollTVA = new EventEmitter<any>();

  paramSociete = [];
  default = 0;
  nbdigit;
  result: any[] = [];
  listCompte = [];
  compte;
  regimeTva = [
    { id: 1, libelleObjetEntite: 'Exonéré de TVA' },
    { id: 3, libelleObjetEntite: 'TVA de plein de droit' },
  ];

  selectedRegime = {};
  droit: any = {};
  user;
  masqueModificationExterne: Boolean = false;
  isComptaClientObligatoire : Boolean = false
  societe: any = {};
  listDesRUM = [];
  @ViewChild('listeRum') listeRum;

  constructor(public common: CommonService, private modalService: BsModalService) { }

  ngOnInit() {
    this.user = this.common.local.getObject('userDetail') || {};
    this.droit['droitFicheCompta'] = ((this.user.clefDroit & 0x00080000) !== 0) ? true : false;
    console.log('droitFicheCompta', this.droit['droitFicheCompta'])
    this.societe = this.common.local.getObject('paramSociete') || {};
    this.paramSociete = this.common.local.getObject('paramSociete').listCompte || [];
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise;
    this.isComptaClientObligatoire = this.common.local.getObject('paramSociete').codeComptaClientObligatoire ? true : false;
    this.compte = this.getCompte(this.detail.comptePaiement ? this.detail.comptePaiement.id : 0) ?
      this.getCompte(this.detail.comptePaiement ? this.detail.comptePaiement.id : 0).numCompte : '';
    this.regimeTva.forEach(elt => {
      if (this.detail['regimeTVA'] === elt.id) {
        this.selectedRegime = elt;
      }
    });
    this.masqueModificationExterne = this.common.local.getObject('paramSociete').URLCreationClient ? true : false;
  }

  getCompte(id) {
    const elem = this.paramSociete.filter(elt => elt.id === id);
    return elem ? elem[0] : '';
  }

  Tofixed(value) {
    return parseFloat(value).toFixed(this.nbdigit);
  }

  searchCompte(event) {
    this.listCompte = [];
    this.paramSociete.forEach(elt => {
      // if (elt.numCompte.startsWith(event) || elt.numCompte.toLowerCase().startsWith(event)) {
      elt.libelleObjetEntite = (elt.nomBanque ? (elt.nomBanque + ' / ') : '') + elt.numCompte;
      this.listCompte.push(elt);
      // }
    });
  }

  showIBANBIC() {
    this.ibanBic.emit();
  }

  showTropPercus() {
    this.tropPercus.emit();
  }

  showMontantTEOM() {
    this.montantsTeom.emit();
  }

  showCompteCollTVA() {
    this.compteCollTVA.emit();
  }

  onChangeFAct(param) {
    if ((param === 'factAgence') && this.detail.factAgence) {
      this.detail.isFactChantier = false;
      this.detail.isFactParChantier = false;
    }

    if ((param === 'isFactChantier') && this.detail.isFactChantier) {
      this.detail.factAgence = false;
      this.detail.factParAgence = false;
    }
  }

  showRUM() {
    this.common.openModal(this.modalService, this.listeRum);
    
    if(!this.detail['id']) {
        this.listDesRUM = this.detail['listRum'] || [];
        return;
    }
    
    const param = {
      'servlet': 'DBGestionRum',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': (this.detail['id'] || 0)
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.chargerListeRumDepuisDatas(datas);
      }
    });
  }
  
  // Charge la variable listDesRUM depuis les résultat d'un service (actualise le tableau)
  chargerListeRumDepuisDatas(datas) {
    this.listDesRUM = datas.data || [];

    this.listDesRUM.forEach(elt => {
      if (elt.dateDebut) {
        elt.dateDebut = moment(elt.dateDebut, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
        elt.dateFiltreDeb = this.common.parseDate(elt.dateDebut);
        elt.modelDebut =  this.common.parseDate(elt.dateDebut);
      }
      if (elt.dateFin) {
        elt.dateFin = moment(elt.dateFin, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
        elt.dateFiltreFin = this.common.parseDate(elt.dateFin);
        elt.modelFin =  this.common.parseDate(elt.dateFin);
      }
    });      
  }
  
  addLigneRum() {
    const today = moment().format('DD/MM/YYYY');
    const objLigne = {
      idAngular: this.listDesRUM.length,
      dateDebut: today,
      dateFin: today,
      modelDebut: this.common.parseDate(today),
      modelFin: this.common.parseDate(today),
      numRum: ''
    }
    
    this.listDesRUM.push(objLigne);
    this.listDesRUM = [...this.listDesRUM];
    
    const length = this.listDesRUM.length - 1;
    setTimeout(function () {
      $('.article' + (length)).focus();
    }, 600);      
  }
  
  enregistrerRum() {
    this.listDesRUM.forEach(rum => {
        rum['nomclass'] = 'Rum';
    });
    
    if(!this.detail['id']) {
        this.detail['listRum'] = this.listDesRUM || [];
        return;
    }    
    
    const param = {
      'servlet': 'DBGestionRum',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': (this.detail['id'] || 0)
        },
        'LIST_RUM': this.listDesRUM
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.chargerListeRumDepuisDatas(datas);
      }
    });      
  }
  
  changeDateDebut(event, row) {
    if (moment(event).isValid()) {
      row['dateDebut'] = moment(event).format('DD/MM/YYYY HH:mm:ss');
      console.log(row['dateDebut']);
    } else {
      row['dateDebut'] = moment().format('DD/MM/YYYY HH:mm:ss');
      console.log(row['dateDebut']);
    }
  }  
  
  changeDateFin(event, row) {
    if (moment(event).isValid()) {
      row['dateFin'] = moment(event).format('DD/MM/YYYY HH:mm:ss');
      console.log(row['dateFin']);
    } else {
      row['dateFin'] = moment().format('DD/MM/YYYY HH:mm:ss');
      console.log(row['dateFin']);
    }
  }
  
  selectDate(event, id) {
     this.common.focusElement(id);
  }  
  
  deleteLigneRum(row) {
    const temp = this.listDesRUM.filter(elt => elt !== row);
    this.listDesRUM = temp;
  }  
}

